import { render } from "./notifications.vue?vue&type=template&id=415517d2"
import script from "./notifications.vue?vue&type=script&lang=js"
export * from "./notifications.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/admin/notifications/notifications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "415517d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('415517d2', __exports__)) {
    console.log('reload')
    api.reload('415517d2', __exports__)
  }
  
  module.hot.accept("./notifications.vue?vue&type=template&id=415517d2", () => {
    console.log('re-render')
    api.rerender('415517d2', render)
  })

}


export default __exports__